import React from 'react';

import {
  PendingInvitationsListPage,
  STAFF_PENDING_INVITATIONS_LIST_QUERY_KEY,
} from '../../shared/users';

export const StaffPendingInvitationsList: React.FC = () => (
  <PendingInvitationsListPage
    queryKeyBase={STAFF_PENDING_INVITATIONS_LIST_QUERY_KEY}
    displayTypePrefKey="StaffPendingInvitations"
    usersRoute="/staff/users"
    showOrganization={true}
    showOrganizationFilter={true}
    linkContext="staff"
  />
);
